import { LayoutWithSidebar, Spinner } from "@swivl-mono/ui";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";
import LocationVarsModel from "../../../Models/Variables/LocationVars.Model";
import { SearchableSidebarLinksList } from "../../SidebarLink/SearchableSidebarLinksList";
import { RouterWorksheetData } from "../Types/Worksheet.Interface";
import { LocationDetailsHeader } from "./Header/Location.Details.Header";
import { Member } from "../../../Models/Member/Member.Current";
import { LocationScope } from "@swivl-mono/types";

interface Props {
  page: string;
  data: RouterWorksheetData[];
  showHeader?: boolean;
}

export function WorksheetLayoutView(props: Props) {
  const page = usePropertiesGetLocationIds();
  const { isLoaded } = LocationVarsModel.useState();
  useEffect(() => {
    LocationVarsModel.loadAllVariables();
  }, []);
  const shouldHide = page.type === LocationScope.ORG && !Member.canSeeOrgSettings ? true : false;
  if (shouldHide) {
    return (<>  </>)
  }
  return (
    <LayoutWithSidebar
      sidebar={<SearchableSidebarLinksList page={page} prefix={page.preamble + "/page/" + props.page} postfix={page.action} items={props.data} />}
      contentNoPadding={true}
      content={
        !isLoaded ? (
          <Spinner />
        ) : props.showHeader ? (
          <LocationDetailsHeader {...page} key={"p" + page.path}>
            <Outlet />
          </LocationDetailsHeader>
        ) : (
          <div className="p-5" key={"o" + page.path}>
            <Outlet />
          </div>
        )
      }
    />
  );
}
